(() => {
  const rawLabels = document.getElementById('wisco-life-labels')?.dataset;
  if (!rawLabels) return;
  const decoder = document.createElement('textarea');
  const labels = Object.fromEntries(Object.entries(rawLabels).map(([key, value]) => { decoder.innerHTML = value; return [key, decoder.value]; }));
  const key = 'wisco-saved-gear-v1';
  const valid = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,180}$/.test(value);
  const clean = value => Array.isArray(value) ? [...new Set(value.filter(valid))].slice(0, 24) : [];
  let persistent = true, saved = new Set(), generation = 0;
  try { saved = new Set(clean(JSON.parse(localStorage.getItem(key) || '[]'))); } catch { persistent = false; }
  const params = new URLSearchParams(location.search);
  const shared = clean((params.get('gear') || '').split(','));
  const sharedView = params.has('gear') && !params.has('mine');
  const root = window.Shopify?.routes?.root || '/';
  const list = document.querySelector('[data-gear-list]');
  const status = document.getElementById('wisco-gear-status');
  const node = (tag, text, className) => {
    const el = document.createElement(tag);
    if (text) el.textContent = text;
    if (className) el.className = className;
    return el;
  };
  function sync() {
    document.querySelectorAll('[data-save-gear]').forEach(button => {
      const active = saved.has(button.dataset.saveGear);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(active));
      button.textContent = active ? labels.saved : labels.save;
      button.setAttribute('aria-label', `${active ? labels.remove : labels.save} ${button.dataset.productTitle || button.dataset.saveGear}`);
    });
    document.querySelectorAll('[data-gear-count]').forEach(counter => { counter.textContent = saved.size; counter.hidden = saved.size === 0; });
    document.querySelectorAll('[data-gear-note]').forEach(note => { note.textContent = persistent ? labels.savedNote : labels.savedSession; });
  }
  async function render() {
    if (!list) return;
    const turn = ++generation;
    const handles = sharedView ? shared : [...saved];
    const empty = document.querySelector('[data-gear-empty]');
    const loading = document.querySelector('[data-gear-loading]');
    list.replaceChildren(); empty.hidden = handles.length > 0; loading.hidden = !handles.length;
    document.querySelector('[data-share-gear]').hidden = !handles.length;
    document.querySelector('[data-own-gear]').hidden = !sharedView;
    if (sharedView) document.getElementById('saved-gear-heading').textContent = labels.shared;
    const items = await Promise.all(handles.map(async handle => {
      try {
        const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {headers: {Accept: 'application/json'}});
        if (response.status === 404) return {handle, missing: true};
        if (!response.ok) throw new Error('Product unavailable');
        return {handle, product: await response.json()};
      } catch { return {handle, failed: true}; }
    }));
    if (turn !== generation) return;
    loading.hidden = true;
    items.forEach(({handle, product, missing, failed}) => {
      const card = node('article', '', 'wisco-gear-card');
      const url = `${root}products/${encodeURIComponent(handle)}`;
      if (product?.featured_image) {
        const link = node('a', '', 'wisco-gear-photo'); link.href = url; link.tabIndex = -1; link.setAttribute('aria-hidden', 'true');
        const photo = node('img'); photo.alt = product.title; photo.loading = 'lazy'; photo.width = 500; photo.height = 500;
        const imageUrl = new URL(product.featured_image, location.origin);
        if (imageUrl.protocol === 'https:') { imageUrl.searchParams.set('width', '500'); photo.src = imageUrl.href; link.append(photo); card.append(link); }
      }
      const copy = node('div', '', 'wisco-gear-copy');
      const title = node('h3', product?.title || handle.replace(/-/g, ' ')); copy.append(title);
      if (missing || failed) copy.append(node('p', missing ? labels.unavailable : labels.loadError));
      if (product) {
        const price = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: window.Shopify?.currency?.active || labels.currency || 'USD'}).format(product.price_min / 100);
        copy.append(node('p', `${product.price_varies ? labels.from + ' ' : ''}${price}`));
      }
      if (!missing) { const link = node('a', product?.available ? labels.view : labels.viewProduct, 'wisco-text-link'); link.href = url; copy.append(link); }
      const button = node('button', '', 'wisco-save-gear'); button.type = 'button'; button.dataset.saveGear = handle; button.dataset.productTitle = product?.title || handle;
      // A missing item can still be removed from a personal saved list.
      if (!missing || saved.has(handle)) copy.append(button);
      card.append(copy); list.append(card);
    });
    sync();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-save-gear]');
    if (!button) return;
    event.preventDefault(); const handle = button.dataset.saveGear;
    if (!valid(handle)) return;
    if (saved.has(handle)) saved.delete(handle);
    else if (saved.size >= 24) { status.textContent = labels.limit; return; }
    else saved.add(handle);
    try { localStorage.setItem(key, JSON.stringify([...saved])); } catch { persistent = false; }
    sync(); status.textContent = persistent ? labels.savedStatus : labels.savedSession;
    const focusIndex = list && list.contains(button) ? [...list.querySelectorAll('button')].indexOf(button) : -1;
    render().then(() => { if (focusIndex >= 0) { const buttons = [...list.querySelectorAll('button')]; (buttons[Math.min(focusIndex, buttons.length - 1)] || document.querySelector('[data-gear-empty]'))?.focus(); } });
  });
  document.querySelector('[data-share-gear]')?.addEventListener('click', async () => {
    const url = new URL('/pages/wisconsin-hub', location.origin);
    url.searchParams.set('gear', (sharedView ? shared : [...saved]).join(',')); url.hash = 'saved-gear';
    const message = document.querySelector('[data-gear-share-status]');
    const fallback = document.querySelector('[data-gear-share-url]');
    try { await navigator.clipboard.writeText(url.href); message.textContent = labels.copied; fallback.hidden = true; }
    catch { message.textContent = labels.copyError; fallback.value = url.href; fallback.hidden = false; fallback.focus(); fallback.select(); }
  });
  window.addEventListener('storage', event => {
    if (event.key !== key) return;
    try { saved = new Set(clean(JSON.parse(event.newValue || '[]'))); } catch { saved = new Set(); }
    sync(); render();
  });
  // Shopify filtering/quick views replace product cards after initial load.
  const observer = new MutationObserver(records => { if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('[data-save-gear]') || n.querySelector?.('[data-save-gear]'))))) sync(); });
  observer.observe(document.body, {childList: true, subtree: true});
  sync(); render();

  const icsEscape = text => text.replace(/\\/g, '\\\\').replace(/\r?\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
  const fold = line => {
    let output = '', current = '', bytes = 0;
    for (const character of line) {
      const size = new TextEncoder().encode(character).length;
      if (bytes + size > 73) { output += current + '\r\n '; current = ''; bytes = 1; }
      current += character; bytes += size;
    }
    return output + current;
  };
  const events = [...document.querySelectorAll('[data-event-id]')];
  function expire() {
    events.forEach(card => { card.hidden = Date.parse(card.dataset.eventExpires) <= Date.now(); });
    const empty = document.querySelector('[data-events-empty]');
    if (empty) empty.hidden = events.some(card => !card.hidden);
  }
  events.forEach(card => {
    const button = card.querySelector('[data-event-calendar]');
    if (!/^\d{4}-\d{2}-\d{2}$/.test(card.dataset.eventStart) || !/^\d{4}-\d{2}-\d{2}$/.test(card.dataset.eventEnd) || card.dataset.eventEnd <= card.dataset.eventStart) return;
    button.hidden = false;
    button.addEventListener('click', () => {
      try {
        const lines = ['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Wisco Outlet//Community Board//EN','CALSCALE:GREGORIAN','BEGIN:VEVENT',`UID:${card.dataset.eventId}-${card.dataset.eventStart}@wiscooutlet.com`,`DTSTAMP:${new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z/, 'Z')}`,`DTSTART;VALUE=DATE:${card.dataset.eventStart.replace(/-/g, '')}`,`DTEND;VALUE=DATE:${card.dataset.eventEnd.replace(/-/g, '')}`,`SUMMARY:${icsEscape(card.querySelector('h3').textContent)}`,`LOCATION:${icsEscape(card.dataset.eventVenue)}`,`DESCRIPTION:${icsEscape(card.querySelector('.wisco-event-details').textContent + '\n' + card.querySelector('.wisco-event-source').href)}`,`URL:${card.querySelector('.wisco-event-source').href}`,'END:VEVENT','END:VCALENDAR'];
        const blob = new Blob([lines.map(fold).join('\r\n') + '\r\n'], {type: 'text/calendar;charset=utf-8'});
        const url = URL.createObjectURL(blob); const link = node('a'); link.href = url; link.download = `wisco-${card.dataset.eventId}.ics`; document.body.append(link); link.click(); link.remove(); setTimeout(() => URL.revokeObjectURL(url), 1000);
        document.querySelector('[data-calendar-status]').textContent = labels.noted;
      } catch { document.querySelector('[data-calendar-status]').textContent = labels.calendarFailed; }
    });
  });
  expire(); document.addEventListener('visibilitychange', () => { if (!document.hidden) expire(); });
  const kind = document.getElementById('WiscoKind');
  if (kind) {
    if ([...kind.options].some(o => o.value === params.get('kind'))) kind.value = params.get('kind');
    const permission = document.getElementById('WiscoPhotoPermission');
    const link = document.getElementById('WiscoSource');
    const photoRow = document.querySelector('[data-photo-permission]');
    const update = () => { permission.required = kind.value === 'photo'; permission.disabled = kind.value !== 'photo'; photoRow.hidden = kind.value !== 'photo'; link.required = kind.value === 'photo' || kind.value === 'event'; };
    kind.addEventListener('change', update); update();
  }
})();
